<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2022-2024, Vector Software BV                             **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Vector Software BV. Unauthorized copying or disclosure of this file,    **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
*****************************************************************************
-->

<template>
    <v-dialog persistent v-model="dialog" style="/*this is not yet working*/min-width: 580px;" width="unset"
        :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-form ref="myForm" v-on:submit.prevent="createtask" :disabled="saving">
            <v-card :min-width="$vuetify.breakpoint.xs ? '100vw' : '600px'" style="min-height: 300px;">
                <v-card-title dense class="text-center justify-center py-6">
                    <div class="text-h3">{{ language.t('Vector.CreateTask.createTask') }}</div>
                </v-card-title>

                <v-alert v-if="error" dense type="warning" dismissible>{{ error }}</v-alert>

                <div v-if="success">
                    <v-card-text class="text-center justify-center py-6">
                        <v-alert dense type="success">{{ language.t('Vector.CreateTask.taskSaved') }}</v-alert>
                    </v-card-text>

                    <v-card-actions class="card-actions">
                        <v-spacer></v-spacer>
                        <v-btn v-on:click="clearForm()">
                            <v-icon>mdi-folder-plus-outline</v-icon>{{ language.t('Vector.CreateTask.newTask') }}
                        </v-btn>
                        <v-btn v-on:click="openTask()" :loading="loading">
                            <v-icon>mdi-map-search-outline</v-icon>{{ language.t('Vector.CreateTask.viewTask') }}
                        </v-btn>
                    </v-card-actions>
                </div>

                <div v-show="!success">
                    <v-card-text class="text-center justify-center py-6">
                        <v-file-input v-model="form.file" ref="fileupload"
                            :placeholder="language.t('Vector.CreateTask.chooseFile')" @change="onSelectFile"
                            accept=".csv,.dxf,.log" truncate-length="15" :rules="[fileSupported]"></v-file-input>

                        <v-file-input v-model="form.env_file" ref="fileuploadVector" placeholder="Kies omgevingstekening"
                            @change="onSelectFileEnviroment" accept=".dxf" truncate-length="15"
                            :rules="[fileSupported]"></v-file-input>

                        <ProjectionSelect v-model="form.projection" />

                        <v-text-field v-model="form.name" ref="name" :placeholder="language.t('Vector.CreateTask.taskName')"
                            maxlength="45"></v-text-field>

                        <v-text-field v-model="form.description" ref="description"
                            :placeholder="language.t('Vector.CreateTask.description')"></v-text-field>

                    </v-card-text>

                    <v-card-actions class="card-actions">
                        <v-spacer></v-spacer>
                        <v-btn color="error" x-large v-on:click="closeDialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-btn color="success" x-large type="submit"
                            :disabled="!complete || saving || (fileSupported !== true)">
                            <v-icon>mdi-check</v-icon>
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-form>
    </v-dialog>
</template>
  
<script>
import ProjectionSelect from "../formfields/ProjectionSelect";
//TODO: request update to dxf package.
import DXFFile from "../../webcomponents/models/DXFFile";
import * as CONST from "../../Constants";

export default {
    components: {
        ProjectionSelect,
    },
    props: {},
    data() {
        return {
            dialog: true,
            complete: false,
            saving: false,
            error: null,
            success: false,
            task: null,
            fileSupported: true,
            loading: false,

            form: {
                file: null,
                env_file: null,
                name: "",
                description: "",
                type: "",
                projection: "",
            },
        };
    },
    mounted: function () { },
    computed: {},
    watch: {
        form: {
            /* validate if the form data is complete */
            handler(val) {
                if (val.file && val.projection != "" && val.type != "" && val.name != "") this.complete = true;
                else this.complete = false;
            },
            deep: true,
        },
    },
    methods: {
        closeDialog() {
            this.clearForm();
            this.$emit("close");
        },
        onSelectFile(file) {
            if (file == null) {
                this.form.type = "";
                this.fileSupported = true;
                return;
            }

            this.error = null;
            switch (file.type) {
                case "application/dxf":
                    this.form.type = "dxf";
                    break;
                case "":
                    // check file extension
                    if (file.name.toLowerCase().match(/\.[0-9a-z]+$/i)[0] == ".dxf") {
                        this.form.type = "dxf";
                        break;
                    }
                    if (file.name.match(/\.[0-9a-z]+$/i)[0] == ".log") {
                        this.form.type = "motionplan";
                        break;
                    }
                default:
                    this.error = "Wrong file type";
                    return;
            }
            // set taskname to filename if name is still empty
            if (this.form.name == "") {
                this.form.name = file.name.replace(/\.[^/.]+$/, "");
                this.form.name = this.form.name.substring(0, 45);
            }

            this.layers = [];
            if (this.form.type === "dxf") {
                console.log("check file version");
                const reader = new FileReader();
                reader.onload = (res) => {
                    var dxf = new DXFFile(res.target.result);
                    this.checkAcadVerSupport(dxf.parsed.header.acadVer);
                };
                reader.onerror = (err) => console.log(err);
                reader.readAsText(file);
            }
        },
        onSelectFileEnviroment(file) {
            if (file == null) {
                this.form.type = "";
                this.fileSupported = true;
                return;
            }

            // set taskname to filename if name is still empty
            if (this.form.name == "") {
                this.form.name = file.name.replace(/\.[^/.]+$/, "");
                this.form.name = this.form.name.substring(0, 45);
            }

            this.layers = [];
            console.log("check file version");
            const reader = new FileReader();
            reader.onload = (res) => {
                var dxf = new DXFFile(res.target.result);
                this.checkAcadVerSupport(dxf.parsed.header.acadVer);
            };
            reader.onerror = (err) => console.log(err);
            reader.readAsText(file);
        },
        checkAcadVerSupport(versionString) {
            if (CONST.__SUPPORTED_ACADVERS.indexOf(versionString) !== -1) {
                this.fileSupported = true;
            } else {
                this.fileSupported = this.language.t("Vector.CreateTask.unsupportedVersion");
            }
        },
        createtask() {
            this.saving = true;
            this.error = null;
            let data = new FormData();

            data.set("route_file", this.form.file);
            data.set("projection", this.form.projection);
            data.set("name", this.form.name);
            data.set("description", this.form.description);
            data.set("type", this.form.type);
            if (this.form.env_file != null) {
                data.set("env_file", this.form.env_file);
            }
            this.$axios
                .post(route("api.tasks.vct"), data, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then((res) => {
                    this.$emit("taskCreated");
                    this.task = res.data;
                    this.success = true;
                    this.saving = false;
                })
                .catch((error) => {
                    this.saving = false;
                    console.log(error.response.data);
                    if (error.response.data.error) this.error = error.response.data.error;
                    else this.error = "unknown server error";
                });
        },
        openTask() {
            this.loading = true;
            this.$axios.get(route("api.task", this.task.taskId)).then((res) => {
                this.$emit("openTask", res.data);
                this.loading = false;
                this.closeDialog();
            });
        },
        clearForm() {
            this.$refs.fileupload.reset();
            this.form.file = null;
            this.form.projection = "";
            this.form.name = "";
            this.form.description = "";
            this.form.type = "";
            this.error = null;
            this.success = false;
        },
    }
}
</script>
  
<style scoped></style>
  